




import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ListItem extends Vue {
  @Prop({ default: "" }) type!: string;
}
